import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'

export const BestellungBadge = styled.div`
	background: ${colorTheme.restaurant.orders.modalOrder.abortedHeader.badgeBackground};
	color: ${colorTheme.restaurant.orders.modalOrder.abortedHeader.badgeText};
	font-weight: 700;
	text-transform: uppercase;
	text-align: center;
	padding: 0.5em 1em;
	border-radius: 1em;
	width: fit-content;
	margin: 0.5em auto 0.75em;
`
BestellungBadge.displayName = 'BestellungBadge'

export const AbortedHeaderRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25em;
	padding: 0 0 0.5em;
`
AbortedHeaderRoot.displayName = 'AbortedHeaderRoot'

export const Row = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 1em;

	&.bold {
		font-weight: 700;
	}
`
Row.displayName = 'AbortedHeaderRow'

export const Label = styled.span`
	color: ${colorTheme.restaurant.orders.modalOrder.abortedHeader.labelText};
`
Label.displayName = 'AbortedHeaderLabel'

export const Value = styled.span`
	margin-left: 0.375em;
	color: ${colorTheme.restaurant.orders.modalOrder.abortedHeader.valueText};
`
Value.displayName = 'AbortedHeaderValue'
